<template>
  <a-card>
    <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
      <a-form-item label="成果名称" name="name">
        <a-input v-model:value="searchForm.name" placeholder="请输入" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="onReset">重置</a-button>
      </a-form-item>
    </a-form>
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #achievementPicture="{ record }">
        <div style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
          <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.achievementPicture"
            :showList="true" disabled />
        </div>
      </template>
      <template #name="{ record }">
        <a @click="onDetail(record)">{{ record.name }}</a>
      </template>
      <template #dateBirth="{ text }">
        <span>{{ text && text.split(' ')[0] }}</span>
      </template>
      <template #technoSphere="{ text }">
        <dict-render :dict-obj="dictObjs['belong_techField']" :text="text"></dict-render>
      </template>
      <template #evaluateStatus="{ text }">
        <div>
          <span v-if="text == 0">未评价</span>
          <span v-if="text == 1">评价中</span>
          <span v-if="text == 2">已评价</span>
        </div>
      </template>
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="onEdit(record)" v-if="record.evaluateStatus == 0">编辑</a>
          <a @click="onDocking(record)">对接列表</a>
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DockingModal ref="dockingModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import DetailModal from './components/DetailModal';
import DockingModal from './components/DockingModal';
import UserModal from './components/UserModal';
import { tableListMixin, dictMixin } from "@/mixins";
import { achievementInfo, achievementFontInfo } from "@/api/achievementsService";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "成果图片", dataIndex: "achievementPicture", key: "achievementPicture", slots: { customRender: "achievementPicture" } },
  { title: "成果名称", dataIndex: "name", key: "name", slots: { customRender: "name" } },
  // { title: "所属高新技术领域", dataIndex: "technoSphere", key: "technoSphere", slots: { customRender: "technoSphere" } },
  { title: "交易价格(万元)", dataIndex: "transactionValue", key: "transactionValue" },
  { title: "负责人姓名", dataIndex: "principal", key: "principal" },
  { title: "负责人手机号", dataIndex: "principalPhone", key: "principalPhone" },
  { title: "评价状态", dataIndex: "evaluateStatus", key: "evaluateStatus", slots: { customRender: 'evaluateStatus' } },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin],
  components: {
    DetailModal, UserModal, DockingModal
  },
  data() {
    return {
      dictNames: "belong_techField",
      expertOption: [],
      columns,
      queryParam: {},
      listUrl: achievementInfo.pageList,
      listKeyField: "id",
      deleteUrl: achievementInfo.remove,
      editUrl: achievementInfo.saveOrUpdate,
    }
  },
  methods: {
    onAdd() {
      this.onShowModal('userModal');
    },
    onEdit(record) {
      this.getAction({
        url: achievementInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onDetail(record) {
      this.getAction({
        url: achievementInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.getAction({
          url: achievementInfo.eveluation,
          params: { did: record.id, type: record.type }
        }).then(r => {
          let expertArr = r.expertId ? r.expertId.split(',') : [];
          let str = ''
          expertArr.map(item => {
            this.expertOption.map(i => {
              if (i.value == item) {
                str += i.label + ','
              }
            })
          })
          this.getAction({
            url: achievementFontInfo.getAchievementList,
            params: { achievementsId: record.id }
          }).then(a => {
            let aa = a.records
            let obj = {
              ...res,
              assessStatus: r.assessStatus,
              evaluate: r.evaluate,
              report: r.report,
              expertName: str,
              connectArr: aa
            }
            this.onShowModal('detailModal', obj);
          })
        })
      })
    },
    onDocking(record) {
      this.getAction({
        url: achievementFontInfo.getAchievementList,
        params: { achievementsId: record.id }
      }).then(a => {
        let aa = a.records
        let obj = {
          connectArr: aa
        }
        this.onShowModal('dockingModal', obj);
      })
    },
    getExpertOption() {
      this.getAction({
        url: achievementInfo.expertList
      }).then(res => {
        let arr = []
        res.map(item => {
          arr.push({
            label: `${item.realName}(${item.telephone})`,
            value: item.id
          })
        })
        this.expertOption = arr
      })
    },

  },
  mounted() {
    this.getExpertOption()
  }
}
</script>

<style scoped></style>
